import { versionedHttpCollection } from "us.helper/http/collection";

export default {
  calendar: {
    update: (params: any): Promise<any> => {
      return new Promise<{}>(async (resolve, reject) => {
        try {
          const { data, status } = await versionedHttpCollection.post(
            "bmdservice",
            "calendars",
            params,
            "v1"
          );
          if (status == 201) {
            resolve(data);
          } else {
            reject(data);
          }
        } catch (error) {
          reject(error);
        }
      });
    },

    init: <
      P extends {
        calendarId: number;
        dayId: number;
        startDate: string;
        endDate: string;
        criteria: string;
      }
    >(
      params: P
    ): Promise<Array<any>> => {
      const { calendarId, criteria, startDate, endDate, dayId } = params;
      return new Promise<any>(async (resolve, reject) => {
        try {
          /**
           * Get Schedule time
           */
          const scheduleTime = await versionedHttpCollection.get(
            "bmdservice",
            "schedulesDays",
            {
              calendarId,
              dayId,
            },
            "v1"
          );

          /**
           * Get Red Days
           */
          const redDays = await versionedHttpCollection.get(
            "bmdservice",
            `redDays`,
            { calendarId, criteria, startDate, endDate },
            "v1"
          );

          resolve({
            scheduleTime: scheduleTime.status == 200 ? scheduleTime.data : {},
            redDays: redDays.status == 200 ? redDays.data : [],
          });
        } catch (error) {
          reject(error);
        }
      });
    },
  },

  ScheduleTimeSlots: {
    get: <P extends { calendarId: number; dayId: number }>(
      params: P
    ): Promise<any> => {
      return new Promise<{}>(async (resolve, reject) => {
        const { calendarId, dayId } = params;
        try {
          const { data, status } = await versionedHttpCollection.get(
            "bmdservice",
            "schedulesDays",
            {
              calendarId,
              dayId,
            },
            "v1"
          );
          if (status == 200) {
            resolve(data);
          } else {
            reject(data);
          }
        } catch (error) {
          reject(error);
        }
      });
    },
  },
  redDays: {
    get: <
      P extends {
        calendarId: number;
        startDate: string;
        endDate: string;
        criteria: string;
      }
    >(
      params: P
    ): Promise<any> => {
      return new Promise<any>(async (resolve, reject) => {
        try {
          const { data, status } = await versionedHttpCollection.get(
            "bmdservice",
            `nonProductionDays`,
            params,
            "v1"
          );
          if (status == 200) {
            resolve(data);
          } else {
            reject(data);
          }
        } catch (error) {
          reject(error);
        }
      });
    },
    update: (params: any): Promise<any> => {
      return new Promise<{}>(async (resolve, reject) => {
        try {
          const { data, status } = await versionedHttpCollection.post(
            "bmdservice",
            "nonProductionDays",
            params,
            "v1"
          );
          resolve({ data, status });
        } catch (error) {
          reject(error);
        }
      });
    },
    delete: (params: any): Promise<any> => {
      return new Promise<{}>(async (resolve, reject) => {
        try {
          const { data, status } = await versionedHttpCollection.post(
            "bmdservice",
            `nonProductionDays/${params.id}`,
            {},
            "v1"
          );
          resolve({ data, status });
        } catch (error) {
          reject(error);
        }
      });
    },
  },
};
